import { 
    BaseScene,
} from './BaseScene';

import {
    Text,
    Graphics,
    Container,
    Sprite,
    Assets,
} from 'pixi.js';

import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
    FONT_1,
    FONT_UI,
} from '../GameConst';

import {
    CARD_BASE_1,
    CARD_BASE_2,
    CARD_BASE_OUTLINE,
    CARD_BASE,
    CARD_ELEMENT_BASE,
    IMG_SHURIKEN_BASE,
    BATTLE_SHEET,
    HOME_SHEET,
    HEADER_FOOTER_SHEET,
    BACK_TOWER_01,
} from '../CommonAssets';

import { getAPI } from '../utils/API';
import { DeckEditLayer } from './HomeScene/DeckEditLayer';
import { FloorSelectLayer } from './HomeScene/FloorSelectLayer';
import { SpriteButton } from '../components/SpriteButton';
import { ON_BUTTON_EVENT } from '../components/CommonButton';
import { SELECT_TOWER_EVENT, TowerSelectLayer } from './HomeScene/TowerSelectLayer';
import { userDataManager } from '../utils/UserDataManager';

export class HomeScene extends BaseScene {
    resources(){
        return [
            [CARD_BASE.name, CARD_BASE.path],
            [CARD_ELEMENT_BASE.name, CARD_ELEMENT_BASE.path],
            [CARD_BASE_1.name, CARD_BASE_1.path],
            [CARD_BASE_2.name, CARD_BASE_2.path],
            [CARD_BASE_OUTLINE.name, CARD_BASE_OUTLINE.path],
            [IMG_SHURIKEN_BASE.name, IMG_SHURIKEN_BASE.path],
            [BATTLE_SHEET.name, BATTLE_SHEET.path],
            [HOME_SHEET.name, HOME_SHEET.path],
            [HEADER_FOOTER_SHEET.name, HEADER_FOOTER_SHEET.path],
            [BACK_TOWER_01.name, BACK_TOWER_01.path],
        ];
    }
    async Init(){
        this.backContainer = new Container();
        this.addChild(this.backContainer);
        this.homeContainer = new Container();
        this.addChild(this.homeContainer);
        this.layerContainer = new Container();
        this.addChild(this.layerContainer);
        this.headerFooterContainer = new Container();
        this.addChild(this.headerFooterContainer);

        this.towersData = await getAPI('/towers');

        const background = new Graphics();
        background.beginFill(0xaf7b35);
        background.drawRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);
        background.endFill();
        this.backContainer.addChild(background);

        const backgroundTower = new Sprite(Assets.get(BACK_TOWER_01.name));
        this.backContainer.addChild(backgroundTower);

        this.CreateHeaderFooter();
        await this.CreateHome();
    }

    async CreateHome(){
        const buttonContainer = new Container();
        this.homeContainer.addChild(buttonContainer);
        buttonContainer.position.set(SCREEN_WIDTH * 0.5, SCREEN_HEIGHT * 0.25);
        const buttonBattle = new SpriteButton(Assets.get(HOME_SHEET.home_battle));
        const buttonDeck = new SpriteButton(Assets.get(HOME_SHEET.home_deck));
        const buttonRecord = new SpriteButton(Assets.get(HOME_SHEET.home_record), {ignorePivot:false, isNegative:true});
        const buttonEmpty1 = new SpriteButton(Assets.get(HOME_SHEET.home_koujibase01), {ignorePivot:false, isNegative:true});
        const buttonEmpty2 = new SpriteButton(Assets.get(HOME_SHEET.home_koujibase02), {ignorePivot:false, isNegative:true});
        buttonBattle.position.set(0, 0);
        buttonDeck.position.set(buttonBattle.x - 235, buttonBattle.y + 165);
        buttonEmpty1.position.set(buttonBattle.x + 235, buttonBattle.y + 165);
        buttonRecord.position.set(buttonBattle.x - 170, buttonBattle.y + 450);
        buttonEmpty2.position.set(buttonBattle.x + 170, buttonBattle.y + 450);

        buttonContainer.addChild(buttonBattle);
        buttonContainer.addChild(buttonDeck);
        buttonContainer.addChild(buttonRecord);
        buttonContainer.addChild(buttonEmpty1);
        buttonContainer.addChild(buttonEmpty2);

        const empty1 = new Sprite(Assets.get(HOME_SHEET.home_kouji01));
        const empty2 = new Sprite(Assets.get(HOME_SHEET.home_koji02));
        buttonEmpty1.sprite.addChild(empty1);
        buttonEmpty2.sprite.addChild(empty2);
        empty1.y += 70;
        empty2.y += 20;

        buttonBattle.on(ON_BUTTON_EVENT, () => this.ShowTowersLayer());
        buttonDeck.on(ON_BUTTON_EVENT, () => this.ShowDeckEditLayer());
        buttonRecord.on(ON_BUTTON_EVENT, () => {});

        // TODO : 機能解放
        buttonRecord.sprite.tint = 0x444444;
        empty1.tint = 0x444444;
        empty2.tint = 0x444444;

        if(userDataManager.OnchainCards.length){
            const randomOnchainCardIndex = Math.floor(Math.random() * userDataManager.OnchainCards.length);
            const displayOnchainCard = userDataManager.OnchainCards[randomOnchainCardIndex];
            const charaImageUrl = displayOnchainCard.image.replace('auto=format', '');
            const key = `token_${displayOnchainCard.tokenId}`;
            Assets.add(key, charaImageUrl);
            await Assets.load(key).then();
            const charaSprite = new Sprite(Assets.get(key));
            this.homeContainer.addChild(charaSprite);
            charaSprite.scale.set(1.5);
            charaSprite.position.set(SCREEN_WIDTH * 0.48, SCREEN_HEIGHT * 0.46);
        }

        const textFrame = new Sprite(Assets.get(HOME_SHEET.home_textframe));
        textFrame.anchor.set(0.5);
        textFrame.position.set(SCREEN_WIDTH * 0.3, SCREEN_HEIGHT * 0.64);
        this.homeContainer.addChild(textFrame);
        const text = new Text('テキストが入ったよ！', {
            fontFamily: FONT_UI,
            fontSize: 30,
            fill: 'white',
            fontWeight: 'bold',
        });
        text.position.set(textFrame.x - textFrame.width * 0.3, textFrame.y);
        this.homeContainer.addChild(text);

        const scroll = new Sprite(Assets.get(HOME_SHEET.home_scroll));
        const scrollTextFrame = new Sprite(Assets.get(HOME_SHEET.home_scrollbase));
        scroll.anchor.set(0.5);
        scrollTextFrame.anchor.set(0, 0.5);
        scroll.position.set(SCREEN_WIDTH * 0.4, SCREEN_HEIGHT * 0.78);
        scrollTextFrame.position.set(SCREEN_WIDTH * 0.4, SCREEN_HEIGHT * 0.78);
        this.homeContainer.addChild(scrollTextFrame);
        this.homeContainer.addChild(scroll);
    }

    CreateHeaderFooter(){
        const header = new Sprite(Assets.get(HEADER_FOOTER_SHEET.header));
        const footer = new Sprite(Assets.get(HEADER_FOOTER_SHEET.footer));
        footer.y = SCREEN_HEIGHT - footer.height;
        this.headerFooterContainer.addChild(header);
        this.headerFooterContainer.addChild(footer);
        const buttonFooterHome = new SpriteButton(Assets.get(HEADER_FOOTER_SHEET.f_home), {ignorePivot:true});
        const buttonFooterBattle = new SpriteButton(Assets.get(HEADER_FOOTER_SHEET.f_battle), {ignorePivot:true});
        const buttonFooterDeck = new SpriteButton(Assets.get(HEADER_FOOTER_SHEET.f_formation), {ignorePivot:true});
        const buttonFooterRecord = new SpriteButton(Assets.get(HEADER_FOOTER_SHEET.f_results), {ignorePivot:true, isNegative:true});
        const buttonFooterReserve = new SpriteButton(Assets.get(HEADER_FOOTER_SHEET.f_reserve), {ignorePivot:true, isNegative:true});
        buttonFooterHome.sprite.anchor.set(0.5, 1);
        buttonFooterBattle.sprite.anchor.set(0.5, 1);
        buttonFooterDeck.sprite.anchor.set(0.5, 1);
        buttonFooterRecord.sprite.anchor.set(0.5, 1);
        buttonFooterReserve.sprite.anchor.set(0.5, 1);

        // TODO : 機能解放
        buttonFooterRecord.sprite.tint = 0x444444;
        buttonFooterReserve.sprite.tint = 0x444444;

        buttonFooterHome.x = SCREEN_WIDTH * 0.05 + SCREEN_WIDTH * 0.9 * 0.1;
        buttonFooterBattle.x = SCREEN_WIDTH * 0.05 + SCREEN_WIDTH * 0.9 * 0.3;
        buttonFooterDeck.x = SCREEN_WIDTH * 0.05 + SCREEN_WIDTH * 0.9 * 0.5;
        buttonFooterRecord.x = SCREEN_WIDTH * 0.05 + SCREEN_WIDTH * 0.9 * 0.7;
        buttonFooterReserve.x = SCREEN_WIDTH * 0.05 + SCREEN_WIDTH * 0.9 * 0.9;
        buttonFooterHome.y = buttonFooterBattle.y = buttonFooterDeck.y = buttonFooterRecord.y = buttonFooterReserve.y = footer.y + buttonFooterHome.height * 0.8;
        this.headerFooterContainer.addChild(buttonFooterHome);
        this.headerFooterContainer.addChild(buttonFooterBattle);
        this.headerFooterContainer.addChild(buttonFooterDeck);
        this.headerFooterContainer.addChild(buttonFooterRecord);
        this.headerFooterContainer.addChild(buttonFooterReserve);
        buttonFooterHome.on(ON_BUTTON_EVENT, () => this.ShowHome());
        buttonFooterBattle.on(ON_BUTTON_EVENT, () => this.ShowTowersLayer());
        buttonFooterDeck.on(ON_BUTTON_EVENT, () => this.ShowDeckEditLayer());
        buttonFooterRecord.on(ON_BUTTON_EVENT, () => {});
        buttonFooterReserve.on(ON_BUTTON_EVENT, () => {});
    }

    ShowHome(){
        while(true){
            if(!this.layerContainer.children[0]) break;
            this.layerContainer.children[0].destroy({children:true});
        }
    }

    ShowTowersLayer(){
        const layer = new TowerSelectLayer(this.towersData);
        layer.on(SELECT_TOWER_EVENT, (towerId) => {this.ShowFloorsLayer(towerId)});
        this.layerContainer.addChild(layer);
    }

    async ShowFloorsLayer(towerId){
        if(this.isLoadSelectedTower) return;
        if(this.selectedTowerId != towerId) {
            this.selectedTowerId = towerId;
            this.isLoadSelectedTower = true;
            this.selectedfloorsData = await getAPI(`/towers/${this.selectedTowerId}/floors`);
        }
        const layer = new FloorSelectLayer(this.selectedfloorsData.floors);
        this.layerContainer.addChild(layer);
        this.isLoadSelectedTower = false;
    }

    ShowDeckEditLayer(){
        const layer = new DeckEditLayer();
        this.layerContainer.addChild(layer);
    }

    UpdateScene(){
    }
}
